export default __webpack_public_path__ + "static/media/af_template.8f1ce57a.csv";